import { defaultStyles, DefaultExtensionType, FileIconProps } from "react-file-icon";

export const customFileIconStyles: Record<DefaultExtensionType, Partial<FileIconProps>> = {
  ...defaultStyles,
  pdf: {
    ...defaultStyles["pdf"],
    glyphColor: "rgba(255,0,0,1.0)",
    labelUppercase: true,
  },
};
